import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createRef, ref } from 'lit/directives/ref.js';
import '../../components/wui-icon/index.js';
import { elementStyles, resetStyles } from '../../utils/ThemeUtil.js';
import { customElement } from '../../utils/WebComponentsUtil.js';
import styles from './styles.js';
let WuiInputText = class WuiInputText extends LitElement {
  constructor() {
    super(...arguments);
    this.inputElementRef = createRef();
    this.size = 'md';
    this.disabled = false;
    this.placeholder = '';
    this.type = 'text';
  }
  render() {
    const sizeClass = "wui-size-".concat(this.size);
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral([" ", "\n      <input\n        ", "\n        class=", "\n        type=", "\n        enterkeyhint=", "\n        ?disabled=", "\n        placeholder=", "\n        @input=", "\n        value=", "\n      />\n      <slot></slot>"])), this.templateIcon(), ref(this.inputElementRef), sizeClass, this.type, ifDefined(this.enterKeyHint), this.disabled, this.placeholder, this.dispatchInputChangeEvent.bind(this), ifDefined(this.value));
  }
  templateIcon() {
    if (this.icon) {
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<wui-icon\n        data-input=", "\n        size=\"sm\"\n        color=\"inherit\"\n        name=", "\n      ></wui-icon>"])), this.size, this.icon);
    }
    return null;
  }
  dispatchInputChangeEvent() {
    var _this$inputElementRef;
    this.dispatchEvent(new CustomEvent('inputChange', {
      detail: (_this$inputElementRef = this.inputElementRef.value) === null || _this$inputElementRef === void 0 ? void 0 : _this$inputElementRef.value,
      bubbles: true,
      composed: true
    }));
  }
};
WuiInputText.styles = [resetStyles, elementStyles, styles];
__decorate([property()], WuiInputText.prototype, "size", void 0);
__decorate([property()], WuiInputText.prototype, "icon", void 0);
__decorate([property({
  type: Boolean
})], WuiInputText.prototype, "disabled", void 0);
__decorate([property()], WuiInputText.prototype, "placeholder", void 0);
__decorate([property()], WuiInputText.prototype, "type", void 0);
__decorate([property()], WuiInputText.prototype, "keyHint", void 0);
__decorate([property()], WuiInputText.prototype, "value", void 0);
WuiInputText = __decorate([customElement('wui-input-text')], WuiInputText);
export { WuiInputText };
//# sourceMappingURL=index.js.map